import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import images from '../../Utils/images';
import colors from '../../Utils/colors';
import { useNavigate } from 'react-router-dom';

import CloseIcon from '@mui/icons-material/Close';

const AiAgentFeatureBanner = ({ onClose }: { onClose?: () => void }) => {
    const navigate = useNavigate();
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '100vh',
                background: 'rgba(0,0,0,0.85)',
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                zIndex: 2000,
            }}
        >
            {/* Close Button */}
            <Box
                sx={{
                    position: 'absolute',
                    top: 32,
                    right: 32,
                    zIndex: 2100,
                }}
            >
                <Button
                    onClick={() => {
                        onClose && onClose();
                        localStorage.setItem('isAiAgentFeatureBannerSeen', 'true');
                    }}
                    sx={{
                        minWidth: 0,
                        width: 40,
                        height: 40,
                        borderRadius: '50%',
                        background: '#fff',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                        p: 0,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        '&:hover': {
                            background: '#F6F5FF',
                        },
                    }}
                >
                    <CloseIcon sx={{ color: '#7B61FF', fontSize: 28 }} />
                </Button>
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    background: '#fff',
                    borderRadius: '24px',
                    boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
                    maxWidth: 800,
                    width: '90vw',
                    p: 0,
                    overflow: 'hidden',
                }}
            >
                {/* Left Section */}
                <Box sx={{ flex: 1, p: 5, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                    <Typography variant="h5" fontWeight={700} mb={2} color="#222">
                        AI Assistant
                    </Typography>
                    <Typography
  variant="subtitle2"
  fontWeight={600}
  color={colors.primary03}
  mb={1}
>
This is a limited-time trial feature. You can explore it for 45 days and reach out to the support team for any assistance.
</Typography>
                    <Typography variant="body1" color="#444" mb={4}>
                        Create and deploy an AI-powered assistant on your WhatsApp Business account to automatically respond to your customers’ queries.
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 2 }}>
                        <Button
                            variant="contained"
                            sx={{
                                background: colors.primary03,
                                color: '#fff',
                                borderRadius: '8px',
                                px: 4,
                                fontWeight: 600,
                                fontSize: 16,
                                boxShadow: 'none',
                                '&:hover': { background: '#6B51E7' },
                            }}
                            onClick={() => {
                                if (onClose) onClose();
                                localStorage.setItem('isAiAgentFeatureBannerSeen', 'true');
                                navigate('/creator/ai-assistants');
                            }}
                        >
                            Explore
                        </Button>
                        <Button
                            variant="outlined"
                            sx={{
                                borderColor: colors.primary03,
                                color: colors.primary03,
                                borderRadius: '8px',
                                px: 4,
                                fontWeight: 600,
                                fontSize: 16,
                                background: '#F6F5FF',
                                '&:hover': { borderColor: colors.primary03, background: '#ECEBFF' },
                            }}
                            onClick={() => {
                                if (onClose) onClose();
                                localStorage.setItem('isAiAgentFeatureBannerSeen', 'true');
                                window.open('https://www.cheerio.in/post/how-do-you-create-and-deploy-an-ai-assistant-on-whatsapp-or-instagram', '_blank');
                            }}
                        >
                            Learn More
                        </Button>
                    </Box>
                </Box>
                {/* Right Section */}
                <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'transparent', minHeight: 320 }}>
                    <Box
                        sx={{
                            borderRadius: '18px',
                            border: '2px solid #E0E0E0',
                            boxShadow: '0 2px 16px rgba(123,97,255,0.08)',
                            overflow: 'hidden',
                            background: '#F8F8FF',
                            p: 1,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            minWidth: 320,
                            minHeight: 320,
                            maxWidth: 340,
                        }}
                    >
                        <img
                            src={images.AiAgentFeatureBanner}
                            alt="AI Assistant Feature"
                            style={{ width: '100%', height: 'auto', borderRadius: '14px', objectFit: 'cover' }}
                        />
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default AiAgentFeatureBanner;
